import {MockCell, MockState, TaskType} from './types'

/* =========================================================================
   WMS · mock selectors — производные данные поверх MockState. Страницы
   вызывают их с уже полученным через useWmsMockStore() снапшотом (не лезут
   в store.ts напрямую), чтобы не плодить лишние подписки.
   ========================================================================= */

export type NavBadgeTone = 'primary' | 'warning' | 'danger'
export interface NavBadge {
  tone: NavBadgeTone
  count: number
}

/**
 * Счётчик-бейдж пункта сайдбара, порт navCount() из wms-prototype.html.
 * null — бейдж не показываем (0). Не покрывает 'ttc' — та страница теперь
 * реальная (GET /wms/ttc-receipts/clients/), её бейдж считается отдельно
 * прямо в AsideMenuMain.tsx из ttc_receipts в GET /wms/tasks/counters/.
 */
export function navCount(s: MockState, key: string): NavBadge | null {
  let n = 0
  let tone: NavBadgeTone = 'primary'
  if (key === 'dispatch') {
    n = s.tasks.filter((t) => t.state === 'problem').length
    tone = 'danger'
  } else if (key === 'requests') {
    n = s.requests.filter((r) => r.state === 'created').length
  } else if (key === 'handoff') {
    n = s.requests.filter((r) => r.state === 'ready' && r.method === 'pickup').length
  } else if (key === 'delivery') {
    n =
      s.requests.filter((r) => r.state === 'ready' && r.method === 'delivery').length +
      s.tasks.filter((t) => t.type === 'delivery' && !['done', 'cancelled'].includes(t.state)).length
  } else if (key.startsWith('tasks-')) {
    const ty = key.slice(6) as TaskType
    n = s.tasks.filter((t) => t.type === ty && !['done', 'cancelled'].includes(t.state)).length
  }
  return n ? {tone, count: n} : null
}

/** Подсказки ячеек по началу кода: «A» → все A, «A1» → A1-1..A1-3. Занятые не исключаем — место можно доложить. */
export function cellSuggest(cells: MockCell[], q: string, excludeCode?: string | null, limit = 8): MockCell[] {
  const t = (q || '').trim().toUpperCase().replace(/\s+/g, '')
  return cells
    .filter((c) => c.code !== excludeCode && c.type !== 'expedition')
    .filter((c) => !t || c.code.replace('-', '').startsWith(t.replace('-', '')))
    .slice(0, limit)
}
